import * as React from "react";
import type { SVGProps } from "react";
const SvgGift01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.175 21.654V7.69m-1.625-.838a.52.52 0 0 0 .48-.133.52.52 0 0 0 .132-.48c-.155-.633-.726-2.755-1.313-3.342A1.877 1.877 0 0 0 7.2 2.89a1.877 1.877 0 0 0 .007 2.649c.596.596 2.709 1.158 3.343 1.313m1.774-.612a.52.52 0 0 0 .133.48.52.52 0 0 0 .48.132c.634-.155 2.756-.726 3.343-1.313a1.877 1.877 0 0 0 .006-2.649 1.877 1.877 0 0 0-2.648.007c-.597.596-1.159 2.709-1.314 3.343m-9.226 6.337h17.804a.7.7 0 0 0 .698-.698V8.39a.7.7 0 0 0-.698-.699H3.098a.7.7 0 0 0-.698.698v3.491c0 .386.313.698.698.698m16.757 0v8.379a.7.7 0 0 1-.699.698H4.844a.7.7 0 0 1-.699-.698v-8.379z"
    />
  </svg>
);
export default SvgGift01;
